const belowSMPart = {
	"&$row": {
		padding: "50px 0 25px",
	},
	"& $headerCell": {
		width: "100%",
		position: "absolute",
		top: "25px",
		left: 0,
	},
	"& $cellsWrapper": {
		width: "100%",
		justifyContent: "flex-start",
	},
	"& $cell": {
		width: "25%",
		marginLeft: 0,
		marginRight: "12.5%",
	},
	"& $cellIconsItem": {
		display: "inline-block",
		verticalAlign: "top",
		marginRight: "10px",
		width: "18px",
		marginBottom: "5px",
		position: "static",
	},
	"& $cellNameTariff": {
		wordBreak: "break-all",
	},
	"& $cellProviderLogo": {
		maxWidth: "80px",
	},
	"& $cellTextValue": {
		wordBreak: "break-all",
	},
	"& $cellButton": {
		width: "100%",
		fontSize: "12px",
	},
	"& $cellButtonDelete": {
		fontSize: "12px",
	},
	"& $channelsRow": {
		width: "100%",
		display: "flex",
		padding: "25px 0 0",
	},
	"& $channelsRowHeaderCell": {
		width: "100%",
		top: "10px",
		left: 0,
		position: "absolute",
		display: "flex",
		alignItems: "flex-start",
		lineHeight: 1,
	},
	"& $channelsCellsWrapper": {
		width: "100%",
	},
	"& $channelsRowCell": {
		width: "25%",
		marginLeft: 0,
		marginRight: "12.5%",
	},
	"&$rowLowPadding": {
		padding: "60px 0 16px",
	},
	"&$rowCompareChannels": {
		paddingTop: "100px",
	},
};

const belowXSPart = {
	"& $cell": {
		width: "25%",
		marginLeft: 0,
		marginRight: "12.5%",
	},
	"& $cellButtonDelete": {
		width: "100%",
		fontSize: "12px",
		"& .icon24": {
			display: "block",
		},
		"& span:not(.icon24)": {
			display: "none",
		},
	},
	"& $cellButton": {
		width: "100%",
		fontSize: "12px",
		"& .icon24": {
			display: "block",
		},
		"& a": {
			"& span:not(.icon24)": {
				display: "none",
			},
		},
		"& div": {
			"& span:not(.icon24)": {
				display: "none",
			},
		},
	},
};

const styles = (theme) => {
	return {
		row: {
			width: "100%",
			display: "flex",
			flexWrap: "wrap",
			borderBottom: `1px solid rgba(211,206,225,0.5)`,
			padding: "18px 0",
			alignItems: "flex-start",
			position: "relative",
			"&:first-child": {
				paddingTop: 0,
			},
			"&:last-child": {
				borderBottom: "none",
				paddingBottom: 0,
			},
		},
		withPointer: {
			cursor: "pointer",
		},
		withoutPointer: {
			cursor: "default !important",
			color: "#2b1d5d !important",
		},
		asterisk: {
			color: "#23c4a0",
			position: "relative",
			fontSize: "24px",
			left: "-4px",
			top: "-2px",
			lineHeight: 0,
		},
		rowLowPadding: {
			padding: "16px 0",
		},
		rowCompareChannels: {},
		headerCell: {
			width: "50%",
			display: "flex",
			flexWrap: "wrap",
			alignItems: "center",
			alignSelf: "center",
			transform: "translateX(0)",
			transition: "transform .3s linear",
		},
		headerCellText: {
			fontFamily: theme.fonts.medium,
			fontSize: "16px",
			lineHeight: "0.63",
			letterSpacing: "2px",
			color: theme.palette.colors.oneMoreGrey,
			textTransform: "uppercase",
			width: "100%",
		},
		headerCellFilterWrapper: {
			width: "280px",
			marginTop: "17px",
			marginBottom: "10px",
		},
		cellsWrapper: {
			width: "50%",
			display: "flex",
			justifyContent: "space-between",
			alignItems: "flex-start",
		},
		cell: {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "flex-start",
			width: "50%",
			marginLeft: "auto",
			flexShrink: 0,
		},
		cellNameTariff: {
			fontFamily: theme.fonts.bold,
			fontSize: "20px",
			lineHeight: "1.25",
			color: theme.palette.colors.darkSlateBlue,
			wordBreak: "break-all",
		},
		cellProviderLogo: {
			marginBottom: "25px",
			maxWidth: "100%",
			maxHeight: "40px",
			backgroundRepeat: "no-repeat",
			backgroundPosition: "center",
			backgroundSize: "contain",
			width: "auto",
		},
		cellText: {
			display: "flex",
			alignItems: "center",
			"& .icon24": {
				color: theme.palette.colors.lightGrayishViolet,
				fontSize: "14px",
				marginTop: "-5px",
				overflow: "hidden",
			},
			"& $mobileIcon": {
				fontSize: "24px",
				color: theme.palette.colors.purplishBlue,
				marginRight: "10px",
				cursor: "pointer",
			},
		},
		cellTextValue: {
			fontFamily: theme.fonts.medium,
			fontSize: "20px",
			lineHeight: "1.2",
			color: theme.palette.colors.darkSlateBlue,
			marginRight: "5px",
			wordBreak: "keep-all",
			"& $cellTextValueIconInfinity": {
				fontSize: "16px",
				color: theme.palette.colors.darkSlateBlue,
			},
		},
		cellTextValuePurple: {
			fontFamily: theme.fonts.medium,
			fontSize: "20px",
			lineHeight: "1.2",
			color: theme.palette.colors.purplishBlue,
			marginRight: "5px",
			wordBreak: "keep-all",
			cursor: "pointer",
		},
		cellTextValueIconInfinity: {},
		mobileIcon: {},
		cellTextDimension: {
			fontFamily: theme.fonts.medium,
			fontSize: "20px",
			lineHeight: "1.2",
			color: theme.palette.colors.darkSlateBlue,
			marginRight: "15px",
		},
		cellIconsList: {
			display: "flex",
			alignItems: "flex-start",
			flexWrap: "wrap",
			marginTop: "-10px",
		},
		cellIconsItem: {
			marginRight: "10px",
			marginTop: "10px",
			position: "relative",
			"& svg": {
				fill: theme.palette.colors.purplishBlue,
				width: "24px",
				height: "24px",
				"& path": {
					fill: theme.palette.colors.purplishBlue,
				},
			},
		},
		svgGrey: {
			"& svg": {
				fill: theme.palette.colors.cloudyBlue,
				"& path": {
					fill: theme.palette.colors.cloudyBlue,
				},
			},
		},
		svgGreen: {
			"& svg": {
				fill: "#23c4a0",
				"& path": {
					fill: "#23c4a0",
				},
			},
		},
		svgPurple: {
			"& svg": {
				fill: theme.palette.colors.purplishBlue,
				"& path": {
					fill: theme.palette.colors.purplishBlue,
				},
			},
		},
		cellButtonsContainer: {
			display: "flex",
			flexDirection: "column",
			marginTop: "15px",
		},
		cellButton: {
			width: "180px",
			height: "50px",
			borderRadius: "10px",
			border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
			backgroundColor: theme.palette.colors.transparent,
			fontFamily: theme.fonts.bold,
			fontSize: "16px",
			lineHeight: "1",
			letterSpacing: "2px",
			color: theme.palette.colors.purplishBlue,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			textTransform: "uppercase",
			marginBottom: "20px",
			cursor: "pointer",
			padding: 0,
			"& div": {
				display: "flex",
				alignItems: "center",
				"& .icon24": {
					display: "none",
					color: theme.palette.colors.purplishBlue,
					fontSize: "24px",
				},
			},
			"& a": {
				width: "100%",
				alignItems: "center",
				justifyContent: "center",
				textAlign: "center",
				color: theme.palette.colors.purplishBlue,
				"& .icon24": {
					display: "none",
					color: theme.palette.colors.purplishBlue,
					fontSize: "24px",
				},
			},
			// "& .icon24": {
			//     display: "none",
			//     color: theme.palette.colors.purplishBlue,
			//     fontSize: "24px",
			// },
			"&:last-child": {
				marginBottom: 0,
			},
		},
		cellButtonDelete: {
			color: theme.palette.colors.lightGrayishViolet,
			"& .icon24": {
				display: "none",
				color: theme.palette.colors.superLightGrey,
				fontSize: "16px",
			},
		},
		channelsRow: {
			width: "100%",
			display: "flex",
			position: "relative",
		},
		channelsRowHeaderCell: {
			width: "50%",
			fontFamily: theme.fonts.light,
			fontSize: "16px",
			lineHeight: "1.88",
			color: theme.palette.colors.grayishBlue,
			transform: "translateX(0)",
			transition: "transform .3s linear",
		},
		channelsCellsWrapper: {
			width: "50%",
			display: "flex",
			justifyContent: "space-between",
		},
		channelsRowCell: {
			width: "50%",
			fontFamily: theme.fonts.medium,
			fontSize: "26px",
			lineHeight: "1.15",
			color: theme.palette.colors.darkSlateBlue,
			display: "flex",
			alignItems: "center",
			marginLeft: "auto",
			flexShrink: 0,
		},
		channelsRowCellSvg: {
			fill: "#00c853",
			width: "14px",
			marginTop: "5px",
		},
		channelsRowCellSvgOff: {
			fill: "#fd5b72",
		},
		rowColNumber2: {},
		rowColNumber3: {
			"& $headerCell": {
				width: "33%",
			},
			"& $cellsWrapper": {
				width: "67%",
			},
			"& $cell": {
				width: "25%",
				marginLeft: 0,
			},
			"& $channelsRowHeaderCell": {
				width: "33%",
			},
			"& $channelsCellsWrapper": {
				width: "67%",
			},
			"& $channelsRowCell": {
				width: "25%",
				marginLeft: 0,
			},
		},
		rowColNumber4: {
			"& $headerCell": {
				width: "33%",
			},
			"& $cellsWrapper": {
				width: "67%",
			},
			"& $cell": {
				width: "180px",
				marginLeft: 0,
			},
			"& $channelsRowHeaderCell": {
				width: "33%",
			},
			"& $channelsCellsWrapper": {
				width: "67%",
			},
			"& $channelsRowCell": {
				width: "180px",
				marginLeft: 0,
			},
		},
		rowColNumber5: {
			"&$row": {
				padding: "50px 0 25px",
				"&:last-child": {
					paddingTop: "25px",
				},
			},
			"& $headerCell": {
				width: "100%",
				position: "absolute",
				top: "25px",
				left: 0,
			},
			"& $cellsWrapper": {
				width: "100%",
			},
			"& $cell": {
				width: "180px",
				marginLeft: 0,
			},
			"& $cellButton": {
				width: " 160px",
			},
			"& $channelsRow": {
				width: "100%",
				display: "flex",
				padding: "25px 0 0",
			},
			"& $channelsRowHeaderCell": {
				width: "100%",
				top: "10px",
				left: 0,
				position: "absolute",
				display: "flex",
				alignItems: "flex-start",
				lineHeight: 1,
			},
			"& $channelsCellsWrapper": {
				width: "100%",
			},
			"& $channelsRowCell": {
				width: "180px",
				marginLeft: 0,
			},
			"&$rowLowPadding": {
				padding: "50px 0 16px",
			},
			"&$rowCompareChannels": {
				paddingTop: "100px",
			},
		},
		rowColNumber6: {
			"&$row": {
				width: "auto",
				minWidth: "100%",
				padding: "50px 0 25px",
				"&:last-child": {
					paddingTop: "25px",
				},
			},
			"& $headerCell": {
				width: "100%",
				position: "absolute",
				top: "25px",
				left: 0,
			},
			"& $cellsWrapper": {
				width: "100%",
				justifyContent: "flex-start",
			},
			"& $cell": {
				width: "180px",
				marginLeft: 0,
				marginRight: "20px",
				"&:last-child": {
					marginRight: 0,
				},
			},
			"& $cellButton": {
				width: " 160px",
			},
			"& $channelsRow": {
				width: "auto",
				display: "flex",
				padding: "25px 0 0",
			},
			"& $channelsRowHeaderCell": {
				width: "100%",
				top: "10px",
				left: 0,
				position: "absolute",
				display: "flex",
				alignItems: "flex-start",
				lineHeight: 1,
			},
			"& $channelsCellsWrapper": {
				width: "auto",
				justifyContent: "flex-start",
			},
			"& $channelsRowCell": {
				width: "180px",
				marginLeft: 0,
				marginRight: "20px",
				"&:last-child": {
					marginRight: 0,
				},
			},
			"&$rowLowPadding": {
				padding: "50px 0 16px",
			},
			"&$rowCompareChannels": {
				paddingTop: "100px",
			},
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			row: {},
			headerCell: {},
			cellsWrapper: {},
			cell: {},
			cellButtonsContainer: {},
			cellButton: {},
			cellButtonDelete: {},
			channelsRow: {},
			channelsRowHeaderCell: {},
			channelsCellsWrapper: {},
			channelsRowCell: {},
			rowColNumber3: {
				"&$row": {
					justifyContent: "space-between",
				},
				"& $headerCell": {
					width: "33%",
				},
				"& $cellsWrapper": {
					width: "63%",
					display: "flex",
					justifyContent: "space-between",
				},
				"& $cell": {
					width: "30%",
					marginLeft: 0,
				},
				"& $cellButton": {
					width: "140px",
					fontSize: "14px",
				},
				"& $cellButtonDelete": {
					fontSize: "16px",
				},
				"& $channelsRow": {
					justifyContent: "space-between",
				},
				"& $channelsRowHeaderCell": {
					width: "33%",
				},
				"& $channelsCellsWrapper": {
					width: "63%",
				},
				"& $channelsRowCell": {
					width: "30%",
					marginLeft: 0,
				},
			},
			rowColNumber4: {
				"&$row": {
					justifyContent: "space-between",
				},
				"& $headerCell": {
					width: "33%",
				},
				"& $cellsWrapper": {
					width: "65%",
					display: "flex",
					justifyContent: "space-between",
				},
				"& $cell": {
					width: "140px",
				},
				"& $cellButtonsContainer": {
					marginLeft: "-10px",
				},
				"& $cellButton": {
					width: "140px",
					fontSize: "14px",
				},
				"& $cellButtonDelete": {
					fontSize: "16px",
				},
				"& $channelsRow": {
					justifyContent: "space-between",
				},
				"& $channelsRowHeaderCell": {
					width: "33%",
				},
				"& $channelsCellsWrapper": {
					width: "65%",
				},
				"& $channelsRowCell": {
					width: "140px",
					marginLeft: 0,
				},
			},
			rowColNumber5: {
				"& $headerCell": {
					width: "100%",
					position: "absolute",
					top: "25px",
					left: 0,
				},
				"& $cellsWrapper": {
					width: "100%",
				},
				"& $cell": {
					width: "140px",
					marginLeft: 0,
				},
				"& $cellButton": {
					width: " 140px",
					fontSize: "14px",
				},
				"& $cellButtonDelete": {
					fontSize: "16px",
				},
				"& $channelsRow": {
					width: "100%",
					display: "flex",
					padding: "25px 0 0",
				},
				"& $channelsRowHeaderCell": {
					width: "100%",
					top: "10px",
					left: 0,
					position: "absolute",
					display: "flex",
					alignItems: "flex-start",
					lineHeight: 1,
				},
				"& $channelsCellsWrapper": {
					width: "100%",
				},
				"& $channelsRowCell": {
					width: "140px",
					marginLeft: 0,
				},
			},
			rowColNumber6: {
				"& $cell": {
					width: "140px",
				},
				"& $cellButton": {
					width: " 140px",
					fontSize: "14px",
				},
				"& $cellButtonDelete": {
					fontSize: "16px",
				},
				"& $channelsRowCell": {
					width: "140px",
				},
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			row: {
				padding: "50px 0 25px",
			},
			headerCell: {
				width: "100%",
				position: "absolute",
				top: "25px",
				left: 0,
			},
			cellsWrapper: {
				width: "100%",
			},
			cell: {
				width: "50%",
				marginLeft: 0,
			},
			cellNameTariff: {
				fontSize: "18px",
				lineHeight: "1.39",
			},
			cellTextValue: {
				fontSize: "18px",
			},
			cellTextDimension: {
				fontSize: "18px",
			},
			cellButtonsContainer: {
				marginTop: 0,
			},
			cellButton: {
				width: "230px",
				fontSize: "14px",
			},
			cellButtonDelete: {
				fontSize: "16px",
			},
			channelsRow: {
				width: "100%",
				display: "flex",
				padding: "25px 0 0",
			},
			channelsRowHeaderCell: {
				width: "100%",
				top: "10px",
				left: 0,
				position: "absolute",
				display: "flex",
				alignItems: "flex-start",
				lineHeight: "1",
			},
			channelsCellsWrapper: {
				width: "100%",
			},
			channelsRowCell: {
				width: "50%",
				marginLeft: 0,
			},
			rowLowPadding: {
				padding: "60px 0 16px",
			},
			rowCompareChannels: {
				paddingTop: "100px",
			},
			rowColNumber2: {
				"& $cell": {
					"&:last-child": {
						paddingLeft: "70px",
					},
				},
				"& $channelsRowCell": {
					"&:last-child": {
						paddingLeft: "70px",
					},
				},
				"&$rowLowPadding": {
					padding: "60px 0 16px",
				},
				"&$rowCompareChannels": {
					paddingTop: "100px",
				},
			},
			rowColNumber3: {
				"&$row": {
					padding: "50px 0 25px",
				},
				"& $headerCell": {
					width: "100%",
					position: "absolute",
					top: "25px",
					left: 0,
				},
				"& $cellsWrapper": {
					width: "100%",
				},
				"& $cell": {
					width: "170px",
					marginLeft: 0,
				},
				"& $cellNameTariff": {
					wordBreak: "normal",
				},
				"& $cellButton": {
					width: "170px",
					fontSize: "14px",
				},
				"& $cellButtonDelete": {
					fontSize: "16px",
				},
				"& $channelsRow": {
					width: "100%",
					display: "flex",
					padding: "25px 0 0",
				},
				"& $channelsRowHeaderCell": {
					width: "100%",
					top: "10px",
					left: 0,
					position: "absolute",
					display: "flex",
					alignItems: "flex-start",
					lineHeight: "1",
				},
				"& $channelsCellsWrapper": {
					width: "100%",
				},
				"& $channelsRowCell": {
					width: "170px",
					marginLeft: 0,
				},
				"&$rowLowPadding": {
					padding: "60px 0 16px",
				},
				"&$rowCompareChannels": {
					paddingTop: "100px",
				},
			},
			rowColNumber4: {
				"&$row": {
					padding: "50px 0 25px",
				},
				"& $headerCell": {
					width: "100%",
					position: "absolute",
					top: "25px",
					left: 0,
				},
				"& $cellsWrapper": {
					width: "100%",
				},
				"& $cell": {
					width: "170px",
					marginLeft: 0,
					marginRight: "10px",
				},
				"& $cellNameTariff": {
					wordBreak: "normal",
				},
				"& $cellButton": {
					width: "150px",
					fontSize: "14px",
				},
				"& $cellButtonDelete": {
					fontSize: "16px",
				},
				"& $channelsRow": {
					width: "100%",
					display: "flex",
					padding: "25px 0 0",
				},
				"& $channelsRowHeaderCell": {
					width: "100%",
					top: "10px",
					left: 0,
					position: "absolute",
					display: "flex",
					alignItems: "flex-start",
					lineHeight: "1",
				},
				"& $channelsCellsWrapper": {
					width: "100%",
				},
				"& $channelsRowCell": {
					width: "170px",
					marginLeft: 0,
					marginRight: "10px",
				},
				"&$rowLowPadding": {
					padding: "60px 0 16px",
				},
				"&$rowCompareChannels": {
					paddingTop: "100px",
				},
			},
			rowColNumber5: {
				"&$row": {
					padding: "50px 0 25px",
				},
				"& $headerCell": {
					width: "100%",
					position: "absolute",
					top: "25px",
					left: 0,
				},
				"& $cellsWrapper": {
					width: "100%",
				},
				"& $cell": {
					width: "170px",
					marginLeft: 0,
					marginRight: "10px",
				},
				"& $cellNameTariff": {
					wordBreak: "normal",
				},
				"& $cellButton": {
					width: "150px",
					fontSize: "14px",
				},
				"& $cellButtonDelete": {
					fontSize: "16px",
				},
				"& $channelsRow": {
					width: "100%",
					display: "flex",
					padding: "25px 0 0",
				},
				"& $channelsRowHeaderCell": {
					width: "100%",
					top: "10px",
					left: 0,
					position: "absolute",
					display: "flex",
					alignItems: "flex-start",
					lineHeight: "1",
				},
				"& $channelsCellsWrapper": {
					width: "100%",
				},
				"& $channelsRowCell": {
					width: "170px",
					marginLeft: 0,
					marginRight: "10px",
				},
				"&$rowLowPadding": {
					padding: "60px 0 16px",
				},
				"&$rowCompareChannels": {
					paddingTop: "100px",
				},
			},
			rowColNumber6: {
				"&$row": {
					padding: "50px 0 25px",
				},
				"& $headerCell": {
					width: "100%",
					position: "absolute",
					top: "25px",
					left: 0,
				},
				"& $cellsWrapper": {
					width: "100%",
				},
				"& $cell": {
					width: "170px",
					marginLeft: 0,
					marginRight: "10px",
				},
				"& $cellNameTariff": {
					wordBreak: "normal",
				},
				"& $cellButton": {
					width: "150px",
					fontSize: "14px",
				},
				"& $cellButtonDelete": {
					fontSize: "16px",
				},
				"& $channelsRow": {
					width: "100%",
					display: "flex",
					padding: "25px 0 0",
				},
				"& $channelsRowHeaderCell": {
					width: "100%",
					top: "10px",
					left: 0,
					position: "absolute",
					display: "flex",
					alignItems: "flex-start",
					lineHeight: "1",
				},
				"& $channelsCellsWrapper": {
					width: "100%",
				},
				"& $channelsRowCell": {
					width: "170px",
					marginLeft: 0,
					marginRight: "10px",
				},
				"&$rowLowPadding": {
					padding: "60px 0 16px",
				},
				"&$rowCompareChannels": {
					paddingTop: "100px",
				},
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			row: {
				padding: "50px 0 25px",
				"&:last-child": {
					paddingTop: "20px",
				},
			},
			cellText: {
				flexWrap: "wrap",
			},
			headerCell: {
				width: "100%",
				position: "absolute",
				top: "20px",
				left: 0,
			},
			headerCellText: {
				fontSize: "14px",
				lineHeight: 1,
			},
			headerCellFilterWrapper: {
				width: "100%",
				marginTop: "17px",
				marginBottom: "10px",
			},
			cellsWrapper: {
				width: "100%",
			},
			cell: {
				width: "50%",
				marginLeft: 0,
			},
			cellIconsItem: {
				display: "inline-block",
				verticalAlign: "top",
				marginRight: "10px",
				width: "18px",
				marginBottom: "5px",
				position: "static",
			},
			cellNameTariff: {
				fontSize: "16px",
				lineHeight: "1.25",
			},
			cellProviderLogo: {},
			cellTextValue: {
				fontSize: "14px",
			},
			cellTextDimension: {
				fontSize: "14px",
			},
			cellButtonsContainer: {
				marginTop: 0,
				width: "83.33%",
				maxWidth: "133px",
			},
			cellButton: {
				width: "100%",
				fontSize: "12px",
				height: "40px",
			},
			cellButtonDelete: {
				fontSize: "12px",
			},
			channelsRow: {
				width: "100%",
				display: "flex",
				padding: "25px 0 0",
			},
			channelsRowHeaderCell: {
				width: "100%",
				top: "10px",
				left: 0,
				position: "absolute",
				display: "flex",
				alignItems: "flex-start",
				lineHeight: 1,
			},
			channelsCellsWrapper: {
				width: "100%",
			},
			channelsRowCell: {
				width: "50%",
				marginLeft: 0,
			},
			rowLowPadding: {
				padding: "60px 0 16px",
			},
			rowCompareChannels: {
				paddingTop: "100px",
			},
			rowColNumber2: {
				"& $cell": {
					"&:last-child": {
						paddingLeft: "8.33%",
					},
				},
				"& $cellButtonsContainer": {
					width: "100%",
				},
				"& $channelsRowCell": {
					"&:last-child": {
						paddingLeft: "8.33%",
					},
				},
				"&$rowLowPadding": {
					padding: "60px 0 16px",
					"& $cellIconsItem": {
						display: "inline-block",
						verticalAlign: "top",
						marginRight: "10px",
						width: "18px",
						marginBottom: "5px",
						position: "static",
					},
				},
				"&$rowCompareChannels": {
					paddingTop: "100px",
				},
			},
			rowColNumber3: belowSMPart,
			rowColNumber4: belowSMPart,
			rowColNumber5: belowSMPart,
			rowColNumber6: belowSMPart,
		},
		[`@media (max-width: ${theme.media.xs})`]: {
			cell: {},
			cellButton: {},
			rowColNumber3: belowXSPart,
			rowColNumber4: belowXSPart,
			rowColNumber5: belowXSPart,
			rowColNumber6: belowXSPart,
		},
	};
};
export default styles;
